var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMemberSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6889_117866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7602 16.4127C13.7602 17.1327 13.1702 17.7227 12.4502 17.7227H3.72016C3.00016 17.7227 2.41016 17.1327 2.41016 16.4127V14.1827C2.41016 12.1327 4.07016 10.4727 6.12016 10.4727H10.0602",
    stroke: "#717832",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05016 8.04172C9.50819 8.04172 10.6902 6.85975 10.6902 5.40172C10.6902 3.94369 9.50819 2.76172 8.05016 2.76172C6.59212 2.76172 5.41016 3.94369 5.41016 5.40172C5.41016 6.85975 6.59212 8.04172 8.05016 8.04172Z",
    stroke: "#717832",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1904 14.1209C18.1675 14.1209 19.7704 12.5181 19.7704 10.5409C19.7704 8.56376 18.1675 6.96094 16.1904 6.96094C14.2132 6.96094 12.6104 8.56376 12.6104 10.5409C12.6104 12.5181 14.2132 14.1209 16.1904 14.1209Z",
    stroke: "#717832",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6504 13.8125L18.2504 15.1625",
    stroke: "#717832",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0116 15.5146L18.0067 15.962C17.7948 16.0563 17.6995 16.3046 17.7939 16.5165L19.791 21.002C19.8853 21.2139 20.1336 21.3092 20.3455 21.2149L21.3504 20.7675C21.5623 20.6731 21.6576 20.4248 21.5632 20.2129L19.5662 15.7274C19.4718 15.5155 19.2235 15.4202 19.0116 15.5146Z",
    stroke: "#717832",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6889_117866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberSearch);
export default __webpack_public_path__ + "static/media/member-search.ba7fa66f1eb30f55313b00b30208e8a4.svg";
export { ForwardRef as ReactComponent };